import { createContext, useContext, useState } from "react";

const SearchContext = createContext();

export function SearchProvider({ children }) {
  const [globalSearch, setGlobalSearch] = useState("");

  const updateSearch = (searchTerm) => {
    setGlobalSearch(searchTerm);
  };

  const clearSearch = () => {
    setGlobalSearch("");
  };

  return (
    <SearchContext.Provider value={{ 
      globalSearch, 
      updateSearch, 
      clearSearch 
    }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
}